// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CvssVectorOriginSchema } from '../inputTypeSchemas/CvssVectorOriginSchema'

/////////////////////////////////////////
// CVSS DATA SCHEMA
/////////////////////////////////////////

export const CvssDataSchema = z.object({
  vectorOrigin: CvssVectorOriginSchema.nullable(),
  score: z.string(),
  vector: z.string(),
  version: z.string(),
  environmentalScore: z.string().nullable(),
  environmentalVector: z.string().nullable(),
  explanation: z.string().nullable(),
})

export type CvssData = z.infer<typeof CvssDataSchema>

export default CvssDataSchema;
